import { render, staticRenderFns } from "./cg-contact.vue?vue&type=template&id=57e3b166&scoped=true"
import script from "./cg-contact.vue?vue&type=script&lang=js"
export * from "./cg-contact.vue?vue&type=script&lang=js"
import style0 from "./cg-contact.vue?vue&type=style&index=0&id=57e3b166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e3b166",
  null
  
)

export default component.exports